import React from 'react';
import NeoInput from '../neoInput';
import '../../style/components/groupInput.css'

/**
 * This component is used to display differents input in group. For exemple an input text with input radio-button
 *
 * @param type : the type of group ( not used here but must be 'group')
 * @param placeholder : the placeholder ( not used here because we have no input)
 * @param label : the label of group ( not used here because neoInput have already used it)
 * @param description : the description of group ( not used here because neoInput have already used it)
 * @param onChange : action to perform and to spread in each childs
 * @param inputs : the different component in the group
 * @param className : Specific classname of group ( which is spread in childs)
 * @param rest : contain current value of form input
 */
export default function GroupInput({ type, placeholder, label, description, onChange=() => {}, inputs=[], currentValue, value, onBlur=()=>{}, ...rest}){
    const [activeInput, setActiveInput] = React.useState(null);
    return(
        <div className={`wz-input-group`}>
            {inputs.map( ({key, placeholder, label, type, description, className='', props={}, ...rest_input }) => {
                // Copy of input to change props (in order to add in-group behind futur classnames )
                // rest contain current value (necessary for radio-button, props contain className and input can contain inputs)
                let isActive = activeInput === key;
                return <NeoInput
                    isInGroup
                    key={key}
                    currentValue={currentValue}
                    className={`${className} wz-in-group ${isActive ? 'active' : 'inactive'}`}
                    value={value}
                    onChange={(e) => {
                        setActiveInput(key);
                        onChange(e);
                    }}
                    placeholder={placeholder}
                    label={label}
                    description={description}
                    type={type}
                    active={isActive}
                    onBlur={onBlur}
                    {...props}
                    {...rest_input}
                />
                })}
        </div>
    )

}
